/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
} from '@msdyn365-commerce/core';
import { capturePaymentAsync } from '../../../data-actions/generated/DataActionExtension.g';
import { IDXC_CapturePaymentResponse } from '../../../data-actions/generated/DataServiceEntities.g';

/**
 * AfterpayCapturePaymentDataAction Input Action
 */

export class AfterpayCapturePaymentDataActionInput implements IActionInput {
    public token: string = '';
    // TODO: Construct the input needed to run the action
    constructor(token: string) {
        this.token = token;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `AfterpayCapturePayment ${this.token}`;
    public getCacheObjectType = () => 'AfterpayCapturePayment';
    public dataCacheType = (): CacheType => 'request';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: AfterpayCapturePaymentDataActionInput): IActionInput => {
    return args;
    // return new AfterpayCapturePaymentDataActionInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function capturePaymentAfterpayAction(
    input:AfterpayCapturePaymentDataActionInput,
    ctx: IActionContext
):Promise<IDXC_CapturePaymentResponse> {
    // Need to express input as string
    const result: IDXC_CapturePaymentResponse = await capturePaymentAsync({ callerContext: ctx }, input.token);

    return Array.isArray(result) ? result[0] : result;
}

export const IAfterpayCapturePaymentDataActionAction =  createObservableDataAction({
    action: <IAction<IDXC_CapturePaymentResponse>>capturePaymentAfterpayAction,
    input: createInput
});
